/**
 * ComplexProcessPage - Enterprise process orchestration
 *
 * Surfaces the ComplexProcessManagerRefactored from @ferp/workflow-forms for admin/architect users.
 * Provides enterprise-grade process orchestration with multi-step workflow management.
 *
 * Route: /admin/complex-process
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconNetwork } from '@tabler/icons-react';

import { ComplexProcessManagerRefactored } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function ComplexProcessPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="red">
            <IconNetwork size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Complex Process Manager</Title>
            <Text size="sm" c="dimmed">
              Enterprise-grade process orchestration with multi-step workflow management
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ComplexProcessManagerRefactored />
    </Container>
  );
}

export default ComplexProcessPage;
